export default "__VITE_ASSET__oajsFPmG__"